
import { nextTick } from 'vue'

export function useChatWindow() {
  const scrollToBottom = (rootEl) => {
    nextTick(() => {
      const container = rootEl?.querySelector('.overflow-y-auto')
      if (container) container.scrollTop = container.scrollHeight
    })
  }

  const openChat = (rootEl, iscreateUserTokenValid, setIsOpen) => {
    setIsOpen(true)
    if (!iscreateUserTokenValid) return
    scrollToBottom(rootEl)
  }

  return { openChat, scrollToBottom }
}
